import { NOTIFICATION_TOPIC_EMNE_ALIASES } from "./notificationTopicEmneAliases";

/** Canonical `emne` for API/storage (Danish key from notificationTopics). */
export function canonicalNotificationEmne(
  emne: string | null | undefined,
): string | null | undefined {
  if (emne == null || String(emne).trim() === "") return emne;
  const s = String(emne).trim();
  return NOTIFICATION_TOPIC_EMNE_ALIASES[s] ?? s;
}
